import React from 'react'
import cn from 'classnames'
import { isUnresolvedLink } from '@lib/types/content-types'
import { TypeSectionLinkableBoxes } from '../../../lib/types'
import { LinkableBoxItem } from '../../item/linkable-box'
import { PageSection } from '../../page-section'
import { ContentProps } from '../../renderer'
import { TabSection } from '../tabs/tab-section'
import { LinkableBoxesSectionScrollableContent } from './scrollable-content/scrollable-content'

import styles from './linkable-boxes.module.scss'

const LinkableBoxesSectionContent: React.FC<ContentProps<TypeSectionLinkableBoxes>> = ({ structure }) => {
  const {
    fields: { itemLinkableBox = [] },
  } = structure

  return (
    <div className={cn(styles.linkableBoxes, { [styles.singleBox]: itemLinkableBox.length === 1 })}>
      {itemLinkableBox.map((linkableBox, i) => {
        if (isUnresolvedLink(linkableBox)) {
          return null
        }
        return <LinkableBoxItem key={i} structure={linkableBox} />
      })}
    </div>
  )
}

export const LinkableBoxesSection: React.FC<ContentProps<TypeSectionLinkableBoxes>> = ({ className, structure }) => {
  const {
    sys,
    fields: { internalName, heading, background, scrollable },
  } = structure

  return (
    <PageSection
      internalName={internalName}
      sysStructure={sys}
      className={className}
      background={background}
      heading={heading}
    >
      {scrollable ? (
        <LinkableBoxesSectionScrollableContent structure={structure} />
      ) : (
        <LinkableBoxesSectionContent structure={structure} />
      )}
    </PageSection>
  )
}

export const LinkableBoxesSectionForTabs: React.FC<ContentProps<TypeSectionLinkableBoxes>> = ({
  className,
  structure,
}) => {
  const {
    fields: { heading, background },
  } = structure

  return (
    <TabSection className={className} background={background} heading={heading}>
      <LinkableBoxesSectionContent structure={structure} />
    </TabSection>
  )
}
